// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_encounter.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { ArchiveEncounterReq, ArchiveEncounterResp, DeleteEncounterReq, DeleteEncounterResp, GetEncounterReq, GetEncounterResp, ListEncountersReq, ListEncountersResp, RestoreEncounterReq, RestoreEncounterResp, UpdateEncounterDocumentReq, UpdateEncounterDocumentResp, UpdateEncounterReq, UpdateEncounterResp } from "./svc_encounter_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.scribe.EncounterService
 */
export const EncounterService = {
  typeName: "com.diagnocat.scribe.EncounterService",
  methods: {
    /**
     * A deleted encounter answers NotFound unless the caller is an organization
     * API key; so does an archived one unless the caller may view the patient's
     * archive (PatientPermissions.CanViewArchivedEncounters).
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Get
     */
    get: {
      name: "Get",
      I: GetEncounterReq,
      O: GetEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterService.List
     */
    list: {
      name: "List",
      I: ListEncountersReq,
      O: ListEncountersResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterService.Update
     */
    update: {
      name: "Update",
      I: UpdateEncounterReq,
      O: UpdateEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Requires EncounterPermissions.CanArchive; the encounter must be neither
     * archived nor deleted.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Archive
     */
    archive: {
      name: "Archive",
      I: ArchiveEncounterReq,
      O: ArchiveEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Requires EncounterPermissions.CanRestore; the encounter must be archived
     * and not deleted.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Restore
     */
    restore: {
      name: "Restore",
      I: RestoreEncounterReq,
      O: RestoreEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Requires EncounterPermissions.CanDelete; the encounter must not be
     * deleted. An archived encounter can be deleted.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteEncounterReq,
      O: DeleteEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Edits section content, approval, or both. Section edits always reset
     * approval, so Approved is ignored when Sections is non-empty.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.UpdateDocument
     */
    updateDocument: {
      name: "UpdateDocument",
      I: UpdateEncounterDocumentReq,
      O: UpdateEncounterDocumentResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

